var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYanmar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 65,
    viewBox: "0 0 72 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4766 39.75L50.1666 34.08V30.62L36.4766 36.3V39.75Z",
    fill: "#DB1D37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6665 31.27L21.1665 25.25V28.7L35.6665 34.7L50.1665 28.7V25.25L35.6665 31.27Z",
    fill: "#DB1D37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1665 34.08L34.8765 39.75V36.3L21.1665 30.62V34.08Z",
    fill: "#DB1D37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYanmar);
export default __webpack_public_path__ + "static/media/yanmar.ba41fc5a7b47ebe3b038598a5ca900bd.svg";
export { ForwardRef as ReactComponent };